import { IWebLink } from '../../../../../types';

const addHardcodedLinks = ( managedLinks?: IWebLink[]): IWebLink[] => [
  {
    id: 0,
    children: [
      {
        id: 10,
        label: 'Lobster Tails',
        url: '/categories/lobster-tails',
      },
      {
        id: 11,
        label: 'Lobster Rolls',
        url: '/classic-maine-lobster-roll-kit',
      },
      {
        id: 12,
        label: 'Lobster Meat',
        url: '/maine-lobster-meat-frozen',
      },
      {
        id: 13,
        label: 'Live Maine Lobster',
        url: '/categories/live-maine-lobster',
      },
      {
        id: 14,
        label: 'Fresh Catch',
        url: '/categories/fresh-catch',
      },
      {
        id: 15,
        label: 'All Things Lobster',
        url: '/categories/all-things-lobster',
      },
      {
        id: 16,
        label: 'Shop All',
        url: '/categories/shop-all',
      },
    ],
    label: 'Shop All',
  },
  ...managedLinks,
  {
    id: 1,
    children: [
      {
        id: 20,
        label: 'About Us',
        url: 'https://getmainelobster.com/pages/about-us',
      },
      {
        id: 21,
        label: 'Prep Tips',
        url: 'https://getmainelobster.com/blogs/prep-tips',
      },
      {
        id: 22,
        label: 'Recipes',
        url: 'https://getmainelobster.com/blogs/recipes',
      },
      {
        id: 23,
        label: 'FAQs',
        url: 'https://getmainelobster.com/pages/maine-lobster-faqs',
      },
      {
        id: 24,
        label: 'Contact Us',
        url: 'https://getmainelobster.com/pages/about-us#contact_us',
      },
      {
        id: 25,
        label: 'Press Room',
        url: 'https://getmainelobster.com/blogs/press-room',
      },
      {
        id: 26,
        label: 'Insights',
        url: 'https://getmainelobster.com/blogs/insights',
      },
    ],
    label: 'Learn',
  },
];

export default addHardcodedLinks;
